import { useState } from 'react';

const FAQs = [
    {
        question: "¿Qué es el cashback?",
        answer: "El cashback, es un porcentaje de la compra que realizas en los comercios adheridos. Es una nueva fórmula, alternativa a los descuentos. Con la gran diferencia de ser dinero real por tus compras. Gracias a nuestra plataforma, este es un proceso automático y fácil."
    },
    {
        question: "¿Cómo funciona el sistema de recompensas?",
        answer: "El sistema de recompensas funciona de manera sencilla y rápida. Solo sigue estos dos pasos, selecciona la oferta que te interesa y realiza la compra conforme a los términos de la oferta. ¡Y listo! Una vez cumplidos estos pasos, estarás en camino de disfrutar tus recompensas."
    },
    {
		question: "¿Qué hacer si no se acredito mi cashback?",
        answer: "Comunícate con nuestro soporte técnico al correo atencionalcliente@uniqcard.mx"
	}
];

function FAQComponent() {
    return (
        <section className='contenedorPreguntas'>
            {FAQs.map((faq, index) => (
                <div key={index} >
                    <div className='preguntas'>
                        <h3 className='textoPregunta'>
                        {faq.question}
                        </h3>
                        <div className='line'></div>
                    </div>
                    <div className='respuesta'>
                        <p>{faq.answer}</p>
                    </div>
                </div>
            ))}
        </section>
    );
}

export default FAQComponent;

